"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMouseGridXY = exports.getGridXY = exports.activateTarget = exports.getSpellFunc = exports.update = exports.moveTargetOffset = exports.setTargetMode = exports.get = exports.setInputGamepad = exports.setInputKeyboard = exports.setInputMouse = exports.ERogueInputDevice = exports.ERogueTargetMode = void 0;
var mathUtils_sidecar_1 = require("../../../lib/mathUtils-sidecar");
var sprites_sidecar_1 = require("../../../sprites/sprites-sidecar");
var spritesUtil_sidecar_1 = require("../../../sprites/spritesUtil-sidecar");
require("../anims/rogueSpellConeOfWater");
var rogueSpellData_sidecar_1 = require("../anims/rogueSpellData-sidecar");
var rogueCamera_sidecar_1 = require("../camera/rogueCamera-sidecar");
var rogueMaps_1 = require("../map/rogueMaps");
var rogueMaps_sidecar_1 = require("../map/rogueMaps-sidecar");
var rogueMonofont_sidecar_1 = require("../monofont/rogueMonofont-sidecar");
var rogueMouseAreas_sidecar_1 = require("../monofont/rogueMouseAreas-sidecar");
var rogueMonsters_sidecar_1 = require("../monsters/rogueMonsters-sidecar");
var rogueDef_sidecar_1 = require("../rogueDef-sidecar");
var rogueLayers_sidecar_1 = require("../scene/rogueLayers-sidecar");
var ERogueTargetMode;
(function (ERogueTargetMode) {
    ERogueTargetMode[ERogueTargetMode["none"] = 0] = "none";
    // fireball,
    // teleport,
    // coneOfWater,
    // waterBlast,
    // waterbolt,
    // waterball,
    // kineticRock,
    ERogueTargetMode[ERogueTargetMode["spellTarget"] = 1] = "spellTarget";
    ERogueTargetMode[ERogueTargetMode["look"] = 2] = "look";
})(ERogueTargetMode = exports.ERogueTargetMode || (exports.ERogueTargetMode = {}));
// const spellMapping: {
//   [key: number]: (x: number, y: number, activate: boolean) => void
// } = {
//   [ERogueTargetMode.fireball]: rogueSpellFireball.rogueCursorFireball,
//   [ERogueTargetMode.waterball]: rogueSpellWaterball.rogueCursor,
//   [ERogueTargetMode.waterbolt]: rogueSpellWaterbolt.rogueCursor,
//   [ERogueTargetMode.teleport]: rogueSpellTeleport.rogueCursorTeleport,
//   [ERogueTargetMode.coneOfWater]: rogueSpellConeOfWater.rogueCursor,
//   [ERogueTargetMode.waterBlast]: rogueSpellWaterBlast.rogueCursor,
//   [ERogueTargetMode.kineticRock]: rogueSpell_kineticRock.rogueCursor,
// }
var ERogueInputDevice;
(function (ERogueInputDevice) {
    ERogueInputDevice[ERogueInputDevice["mouse"] = 0] = "mouse";
    ERogueInputDevice[ERogueInputDevice["keyboard"] = 1] = "keyboard";
    ERogueInputDevice[ERogueInputDevice["gamepad"] = 2] = "gamepad";
})(ERogueInputDevice = exports.ERogueInputDevice || (exports.ERogueInputDevice = {}));
function setInputMouse() {
    // console.log('setInputMouse')
    get().lastInputDevice = ERogueInputDevice.mouse;
}
exports.setInputMouse = setInputMouse;
function setInputKeyboard() {
    // console.log('setInputKeyboard')
    get().lastInputDevice = ERogueInputDevice.keyboard;
}
exports.setInputKeyboard = setInputKeyboard;
function setInputGamepad() {
    // console.log('setInputGamepad')
    get().lastInputDevice = ERogueInputDevice.gamepad;
}
exports.setInputGamepad = setInputGamepad;
var _obj = null;
function get() {
    if (!_obj) {
        _obj = create();
    }
    return _obj;
}
exports.get = get;
var create = function () {
    var imageCursor = spritesUtil_sidecar_1.spritesUtil.createImage(rogueLayers_sidecar_1.rogueLayers.getLayers().uiOnCam, sprites_sidecar_1.sprites.rogueBorder[0]);
    spritesUtil_sidecar_1.spritesUtil.scale(imageCursor, rogueDef_sidecar_1.rogueDef.scale);
    var imageTileBorder = spritesUtil_sidecar_1.spritesUtil.createImage(rogueLayers_sidecar_1.rogueLayers.getLayers().uiOnCam, sprites_sidecar_1.sprites.rogueBorder[0]);
    spritesUtil_sidecar_1.spritesUtil.scale(imageTileBorder, rogueDef_sidecar_1.rogueDef.scale);
    var obj = {
        imageCursor: imageCursor,
        imageTileBorder: imageTileBorder,
        mode: ERogueTargetMode.none,
        lastInputDevice: ERogueInputDevice.mouse,
        keyboardGridX: -1,
        keyboardGridY: -1,
        spell: null,
    };
    return obj;
};
var setTargetMode = function (mode, spell) {
    if (spell === void 0) { spell = null; }
    get().mode = mode;
    get().spell = spell;
    var p = rogueMonsters_sidecar_1.rogueMonsters.getPlayer();
    var map = rogueMaps_sidecar_1.rogueMaps.getCurrentMap();
    if (p) {
        var nx_1 = p.x + 2;
        var ny_1 = p.y;
        var findInRange = function (range, cb) {
            if (!p) {
                return;
            }
            range = Math.ceil(range);
            for (var i = -range; i < range; i++) {
                for (var j = -range; j < range; j++) {
                    var t = rogueMaps_sidecar_1.rogueMaps.getTile(map, p.x + i, p.y + j);
                    if (t && t.eVision === rogueMaps_1.EVision.Seen) {
                        var d = mathUtils_sidecar_1.mathUtils.distance(p.x, p.y, p.x + i, p.y + j);
                        var m = rogueMonsters_sidecar_1.rogueMonsters.getAt(p.x + i, p.y + j);
                        cb(p.x + i, p.y + j, d, t, m);
                    }
                }
            }
        };
        if (spell) {
            var r = rogueSpellData_sidecar_1.rogueSpellData.getSpellStats(spell.key).range;
            if (spell.targetFinder === 'closest-window') {
                var minD_1 = 9999;
                findInRange(r, function (x, y, d, t) {
                    if (t.eTile === rogueMaps_1.ETile.Window) {
                        if (d < minD_1) {
                            nx_1 = x;
                            ny_1 = y;
                            minD_1 = d;
                        }
                    }
                });
            }
            if (spell.targetFinder === 'closest-large') {
                var minD_2 = 9999;
                findInRange(r, function (x, y, d, t, m) {
                    if (m && m.data.type === 'F') {
                        if (d < minD_2) {
                            nx_1 = x;
                            ny_1 = y;
                            minD_2 = d;
                        }
                    }
                });
                if (minD_2 === 9999) {
                    findInRange(r, function (x, y, d, t, m) {
                        if (m && m.data.type === 'f') {
                            if (d < minD_2) {
                                nx_1 = x;
                                ny_1 = y;
                                minD_2 = d;
                            }
                        }
                    });
                }
            }
            if (spell.targetFinder === 'furthest') {
                var maxD_1 = -9999;
                findInRange(r, function (x, y, d, t, m) {
                    if (m && m.data.isFire) {
                        if (d > maxD_1) {
                            nx_1 = x;
                            ny_1 = y;
                            maxD_1 = d;
                        }
                    }
                });
            }
        }
        get().keyboardGridX = nx_1;
        get().keyboardGridY = ny_1;
    }
};
exports.setTargetMode = setTargetMode;
var moveTargetOffset = function (dx, dy) {
    var obj = get();
    obj.keyboardGridX += dx;
    obj.keyboardGridY += dy;
};
exports.moveTargetOffset = moveTargetOffset;
var update = function () {
    var obj = get();
    var mouse = rogueCamera_sidecar_1.rogueCamera.getAdjustedMousePosition();
    var mouseUI = rogueCamera_sidecar_1.rogueCamera.getUiMousePosition();
    if (rogueMouseAreas_sidecar_1.rogueMouseAreas.isMouseCapturedByMouseArea()) {
        obj.imageCursor.visible = false;
        obj.imageTileBorder.visible = false;
        return;
    }
    //let mouse = common.getPhaserScene().input.mousePointer
    obj.imageCursor.x = mouseUI.mx;
    obj.imageCursor.y = mouseUI.my;
    obj.imageCursor.visible = false;
    // get spot
    var _a = (0, exports.getGridXY)(), gridX = _a.gridX, gridY = _a.gridY;
    obj.imageTileBorder.x = gridX * rogueDef_sidecar_1.rogueDef.sizeX; //- rogueCamera.get().cameraX
    obj.imageTileBorder.y = gridY * rogueDef_sidecar_1.rogueDef.sizeY; //- rogueCamera.get().cameraY
    obj.imageTileBorder.visible = true;
    if (obj.mode === ERogueTargetMode.none) {
        if (obj.lastInputDevice !== ERogueInputDevice.mouse) {
            obj.imageTileBorder.visible = false;
        }
        else {
            obj.imageTileBorder.visible = true;
        }
    }
    if (obj.mode === ERogueTargetMode.look) {
        rogueMonofont_sidecar_1.rogueMonofont.write(1, 1, 'Look mode... esc to cancel');
        obj.imageTileBorder.visible = true;
    }
    // if (obj.mode === ERogueTargetMode.spellTarget) {
    // }
    var spellFunc = (0, exports.getSpellFunc)(); //spellMapping[obj.mode as number]
    if (spellFunc) {
        rogueMonofont_sidecar_1.rogueMonofont.write(1, 1, 'Casting spell... esc to cancel');
        spellFunc(gridX, gridY, false);
    }
    // if (obj.mode === ERogueTargetMode.fireball) {
    //   rogueSpellFireball.rogueCursorFireball(gridX, gridY, false)
    //   // rogueGlyphs.write(gridX, gridY, '*', rogueDef.colors.orange)
    // }
    // if (obj.mode === ERogueTargetMode.teleport) {
    //   rogueSpellTeleport.rogueCursorTeleport(gridX, gridY, false)
    //   // rogueGlyphs.write(gridX, gridY, '*', rogueDef.colors.orange)
    // }
    // if (obj.mode === ERogueTargetMode.coneOfWater) {
    //   rogueSpellConeOfWater.rogueCursor_coneOfWater(gridX, gridY, false)
    //   // rogueGlyphs.write(gridX, gridY, '*', rogueDef.colors.orange)
    // }
};
exports.update = update;
var getSpellFunc = function () {
    var _a;
    var obj = get();
    if (obj.mode === ERogueTargetMode.spellTarget) {
        return (_a = obj.spell) === null || _a === void 0 ? void 0 : _a.targetCursor; //spellMapping[obj.mode as number]
        // if (spellFunc) {
        //   spellFunc(gridX, gridY, false)
        // }
    }
    return null;
};
exports.getSpellFunc = getSpellFunc;
var activateTarget = function () {
    var _a = (0, exports.getGridXY)(), gridX = _a.gridX, gridY = _a.gridY;
    var obj = get();
    // if (obj.mode === ERogueTargetMode.fireball) {
    //   rogueSpellFireball.rogueCursorFireball(gridX, gridY, true)
    // }
    // if (obj.mode === ERogueTargetMode.teleport) {
    //   rogueSpellTeleport.rogueCursorTeleport(gridX, gridY, true)
    // }
    // if (obj.mode === ERogueTargetMode.coneOfWater) {
    //   rogueSpellConeOfWater.rogueCursor_coneOfWater(gridX, gridY, true)
    // }
    var spellFunc = (0, exports.getSpellFunc)(); //spellMapping[obj.mode as number]
    if (spellFunc) {
        spellFunc(gridX, gridY, true);
    }
    if (obj.mode === ERogueTargetMode.look) {
        // Do nothing
    }
    (0, exports.setTargetMode)(ERogueTargetMode.none);
};
exports.activateTarget = activateTarget;
var getGridXY = function () {
    var obj = get();
    if (obj.lastInputDevice === ERogueInputDevice.mouse) {
        return (0, exports.getMouseGridXY)();
    }
    else {
        return { gridX: obj.keyboardGridX, gridY: obj.keyboardGridY };
    }
};
exports.getGridXY = getGridXY;
var getMouseGridXY = function () {
    var mouse = rogueCamera_sidecar_1.rogueCamera.getAdjustedMousePosition();
    // let mouseUI = rogueCamera.getUiMousePosition()
    var gridX = Math.floor(mouse.max / rogueDef_sidecar_1.rogueDef.sizeX + 0.5);
    var gridY = Math.floor(mouse.may / rogueDef_sidecar_1.rogueDef.sizeY + 0.5);
    return { gridX: gridX, gridY: gridY };
};
exports.getMouseGridXY = getMouseGridXY;
